window.Reverb = window.Reverb || {};

Reverb.RemoteTooltip = (function () {
  const tooltipUrlDataAttr = 'tooltip-url';
  const remoteTooltipSelector = `.tooltip[data-${tooltipUrlDataAttr}]`;
  const remoteTooltipAjaxContainerSelector = '[data-remote-tooltip-ajax-container]';

  function init() {
    handleRemoteTooltips();

    // Certain AJAX'd forms load HTML with remote tooltips that
    // necessitate re-initializing tooltips in the DOM
    $(document).on('reverb.ajax_load.complete', remoteTooltipAjaxContainerSelector, (e) => {
      initTips($(remoteTooltipAjaxContainerSelector));
      handleRemoteTooltips();
    });
  }

  function handleRemoteTooltips() {
    bindToPreRender();
    bindToTooltipOpen();
  }

  function bindToPreRender() {
    $(document).on('powerTipPreRender', remoteTooltipSelector, function () {
      const remoteTooltip = new Reverb.RemoteTooltip.Tooltip($(this));
      remoteTooltip.preloadCachedData();
    });
  }

  function bindToTooltipOpen() {
    $(document).on('powerTipOpen', remoteTooltipSelector, function () {
      const remoteTooltip = new Reverb.RemoteTooltip.Tooltip($(this));
      remoteTooltip.updateFromRemote();
    });
  }

  return {
    init,
    tooltipUrlDataAttr,
  };
}());

Reverb.RemoteTooltip.Tooltip = function ($hoverElement) {
  const self = this;
  const loadedDataElement = 'cached-remote-tooltip';

  self.$hoverElement = $hoverElement;

  self.updateFromRemote = function () {
    if (!cachedData()) {
      $.get(remoteUrl()).done((data) => {
        powerTip().html(data);
        cacheLoadedData(data);
        $.powerTip.reposition(self.$hoverElement);
      }).fail(() => {
        powerTip().html('error');
      });
    }
  };

  self.preloadCachedData = function () {
    if (cachedData()) {
      self.$hoverElement.data('powertip', cachedData());
    }
  };

  function cachedData() {
    return self.$hoverElement.data(loadedDataElement);
  }

  function remoteUrl() {
    return self.$hoverElement.data(Reverb.RemoteTooltip.tooltipUrlDataAttr);
  }

  function powerTip() {
    return $('#powerTip');
  }

  function cacheLoadedData(data) {
    self.$hoverElement.data(loadedDataElement, data);
  }
};

$(Reverb.RemoteTooltip.init);
